"use client";

import { useState, useEffect } from "react";
import Link from "next/link";
import { X } from "lucide-react";

export function DisclaimerBanner() {
  const [dismissed, setDismissed] = useState(true);

  useEffect(() => {
    const stored = localStorage.getItem("invest-disclaimer-dismissed");
    if (!stored) setDismissed(false);
  }, []);

  const handleDismiss = () => {
    setDismissed(true);
    localStorage.setItem("invest-disclaimer-dismissed", "true");
  };

  if (dismissed) return null;

  return (
    <div className="fixed bottom-0 left-0 right-0 z-40 bg-navy/95 backdrop-blur-md border-t border-gold/30">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8 py-3 flex items-center justify-between gap-4">
        <p className="text-xs text-white/70">
          Securities offered under SEC Reg D Rule 506(c) to accredited investors
          only. This site is not legal, tax, or investment advice.{" "}
          <Link
            href="/legal/disclosures"
            className="text-gold hover:text-gold-lt underline"
          >
            Full disclosures
          </Link>
          .
        </p>
        <button
          onClick={handleDismiss}
          className="text-white/50 hover:text-white shrink-0"
          aria-label="Dismiss disclaimer"
        >
          <X size={16} />
        </button>
      </div>
    </div>
  );
}
